import { createModelStore } from '@/shared/stores/create-model-store'
import { model11InitialModel } from './initial-state'
import { model11DimensionHandlers } from './dimensions'

export const useModel11Store = createModelStore({
  initialModel: model11InitialModel,
  dimensionHandlers: model11DimensionHandlers,
})
